import { Grid } from '@mui/material';
import { ListWrapper } from '@sahinyazilim/sahinyazilim-components';
import { Loading } from 'common/components/Loading/Loading';
import { useAppSelector } from 'common/context/hooks';
import { useTranslation } from 'react-i18next';
import { ActivePlanBrandCard } from '../ActivePlanBrandCard/ActivePlanBrandCard';
import { ActivePlanCard } from '../ActivePlanCard/ActivePlanCard';
import { PaymentList } from '../PaymentList/PaymentList';

export const ActivePlan = () => {
  const { t } = useTranslation();
  const brand = useAppSelector((state) => state.common.brand);
  const payments = useAppSelector((state) => state.common.payments);
  const currentPlan = useAppSelector((state) => state.common.currentPlan);

  if (payments === undefined) return <Loading />;
  return (
    <ListWrapper title={t('account.accountManagement')}>
      <Grid xs={12} spacing={3} alignItems="start" item container>
        <Grid xs={7} item container>
          {currentPlan === null && (
            <ActivePlanCard
              key="no-package"
              data={{
                usingStatus: 'FREE',
                createdAt: brand?.createdAt,
                updatedAt: brand?.createdAt,
                title: '',
                content: '',
                quantity: 1,
                plan: {
                  title: 'KAPALI',
                },
              }}
            />
          )}
          {currentPlan && (
            <ActivePlanCard key={currentPlan.id} data={currentPlan} />
          )}
          <PaymentList data={payments} />
        </Grid>
        <Grid xs={5} item container>
          <ActivePlanBrandCard />
        </Grid>
      </Grid>
    </ListWrapper>
  );
};
